import { render, staticRenderFns } from "./ChartPOToReview.vue?vue&type=template&id=10f67b6b"
import script from "./ChartPOToReview.vue?vue&type=script&lang=js"
export * from "./ChartPOToReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports